import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { UIButton } from "../../../../components/ui";
import messages from "../../../../assets/locale/messages";
import "./Onboarding.scss";

/**
 * Onboarding step - Welcome and initial introduction to the registration flow.
 * Design: header with logo + EN/AR switcher, centered title, description, Get Started button.
 * Supports English and Arabic (RTL handled by app).
 */
const Onboarding = ({ onNext }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { onboarding: t } = messages[lang];

  return (
    <div className="onboarding-step">
      <div className="onboarding-step__main">
        <h2 className="onboarding-step__title">
          {t.title}{" "}
          <span className="onboarding-step__title-highlight">{t.titleHighlight}</span>
        !
        </h2>

        <p className="onboarding-step__description">{t.description}</p>

        <UIButton
          variant="primary"
          size="large"
          type="button"
          onClick={onNext}
          className="onboarding-step__button"
          endIcon={
            lang === "ar" ? <ArrowLeft size={16} /> : <ArrowRight size={16} />
          }
        >
          {t.getStarted}
        </UIButton>
      </div>
    </div>
  );
};

Onboarding.propTypes = {
  onNext: PropTypes.func,
};

Onboarding.defaultProps = {
  onNext: () => {},
};

export default Onboarding;
